import API from 'utils/api';
import { onSuccess, onError } from 'utils/handlers';

export const baseURI = 'nominas/historico-suspensiones-de-pagos-empleados';

/**
 * GET Historicos Suspensiones de Pagos
 * @param {object} params
 * @returns {Promise<object[]>}
 */
export const getHistoricosSuspensionesDePagos = async (params) => {
  try {
    const response = await API.get(baseURI, { params });
    return response.data;
  } catch (err) {
    onError(err);
  }
  return [];
};

/**
 * GET Historico Suspension de Pago
 * @param {number} id
 * @returns {Promise<object|null>}
 */
export const getHistoricoSuspensionDePago = async (id) => {
  try {
    const response = await API.get(`${baseURI}/${id}`);
    return response.data;
  } catch (err) {
    onError(err);
  }
  return null;
};

/**
 * POST Historico Suspension de Pago
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const postHistoricoSuspensionDePago = async (values) => {
  try {
    const response = await API.post(baseURI, values);
    onSuccess(response, 'Agregado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
  }
  return false;
};

/**
 * PATCH Historico Suspension de Pago
 * @param {number} id
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const patchHistoricoSuspensionDePago = async (id, values) => {
  try {
    const response = await API.patch(`${baseURI}/${id}`, values);
    onSuccess(response, 'Editado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
  }
  return false;
};

/**
 * DELETE Historico Suspension de Pago
 * @param {number} id
 * @returns {Promise<boolean>}
 */
export const deleteHistoricoSuspensionDePago = async (id) => {
  try {
    const response = await API.delete(`${baseURI}/${id}`);
    onSuccess(response, 'Eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
  }
  return false;
};
